/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      // Prefer Shiprocket Smart Cart when available
      if (typeof window.openHummaraCart === 'function' && window.openHummaraCart()) {
        return;
      }
      if (typeof window.hasHummaraSmartCart === 'function' && window.hasHummaraSmartCart()) {
        if (typeof window.openHummaraCartWithRetry === 'function') {
          window.openHummaraCartWithRetry({
            onFail: function () {
              window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
            },
          });
          return;
        }
      }

      /** @type {HTMLElement & {open?: () => void} | null} */
      let drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer && !drawer.open) {
        await customElements.whenDefined('theme-drawer');
        drawer = document.querySelector('theme-drawer#cart-drawer');
      }

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
